module.exports = __webpack_public_path__ + "img/icon-tqjgl.3a7db214.png";